import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
// @mui
import Box from '@mui/material/Box'
// hooks
import { useBoolean } from 'src/hooks/use-boolean'
import { useResponsive } from 'src/hooks/use-responsive'
// components
import { useSettingsContext } from 'src/components/settings'
import { Confirm } from 'src/components/custom-dialog'
//
import Main from './main'
import Header from './header'
import NavMini from './nav-mini'
import NavVertical from './nav-vertical'
import { getSidebar } from '../../reducers/app'
import keycloak from '../../utils/keycloak'

// ----------------------------------------------------------------------

export default function DefaultLayout({ children }) {
  const settings = useSettingsContext()

  const lgUp = useResponsive('up', 'lg')

  const nav = useBoolean()

  const isMini = settings.themeLayout === 'mini'

  const renderNavMini = <NavMini />

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />

  const dispatch = useDispatch()

  useEffect(() => {
    if (keycloak.isLoggedIn()) {
      dispatch(getSidebar())
    }
  }, [dispatch])

  if (isMini) {
    return (
      <>
        <Confirm />

        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}

          <Main>{children}</Main>
        </Box>
      </>
    )
  }

  return (
    <>
      <Confirm />

      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        {renderNavVertical}

        <Main>{children}</Main>
      </Box>
    </>
  )
}

DefaultLayout.propTypes = {
  children: PropTypes.node,
}
